import { Group, Toast } from 'services'

const mixin = {
  data() {
    return {
      groupsToAdd: [],
      groupsToRemove: []
    }
  },
  computed: {
    groups() {
      return this.$store.state.group.items
    },
    areGroupsEdited() {
      return !_.isEmpty(this.groupsToAdd) || !_.isEmpty(this.groupsToRemove)
    },
    savedGroups() {
      return [] // NOTE: Override this in the component
    },
    editedGroups() {
      return _.filter(this.savedGroups, g => !_.includes(this.groupsToRemove, g.id)).concat(
        this.groupsToAdd
      )
    }
  },
  methods: {
    groupSelected(group) {
      const affiliationExists =
        this.savedGroups.some(g => group.id === g.id) ||
        this.groupsToAdd.some(g => group.id === g.id)

      if (!affiliationExists) {
        this.groupsToAdd.push(group)
      } else {
        this.groupsToRemove = this.groupsToRemove.filter(g => group.id !== g)
      }
    },
    groupRemoved(group) {
      const affiliationExists = this.savedGroups.some(g => group.id === g.id)

      if (affiliationExists) {
        this.groupsToRemove.push(group.id)
      } else {
        this.groupsToAdd = this.groupsToAdd.filter(g => group.id !== g.id)
      }
    },
    groupCreated(groupName) {
      return this.createGroup({ name: groupName }).then(groupId => {
        const newGroup = {
          id: groupId,
          name: groupName
        }
        this.groupsToAdd.push(newGroup)
        return newGroup
      })
    },
    createGroup(group) {
      return Group.createGroup(group)
        .then(res => {
          Toast.success(this.$i18n.t('CREATED', { thing: this.$i18n.tc('GROUP', 1) }), {
            remove: 5000
          })
          return res.id
        })
        .catch(err => {
          Toast.error(
            this.$i18n.t('ERR', {
              action: this.$i18n.t('CREATE', { thing: this.$i18n.tc('GROUP', 1) })
            })
          )
          console.error(err)
        })
    },
    saveGroups(propName, entityId) {
      return Promise.all([
        ...this.groupsToRemove.map(groupId => {
          return Group.removeAffiliate(propName, groupId, entityId)
        }),
        ...this.groupsToAdd.map(group => Group.addAffiliate(propName, group.id, entityId))
      ]).then(() => {
        this.resetGroupChanges()
      })
    },
    resetGroupChanges() {
      this.groupsToAdd = []
      this.groupsToRemove = []
    }
  },

  created() {
    Group.readAllGroups()
  }
}
export default mixin
